"use strict";

/******/(function (modules) {
	// webpackBootstrap
	/******/ // The module cache
	/******/var installedModules = {};

	/******/ // The require function
	/******/function __webpack_require__(moduleId) {

		/******/ // Check if module is in cache
		/******/if (installedModules[moduleId])
			/******/return installedModules[moduleId].exports;

		/******/ // Create a new module (and put it into the cache)
		/******/var module = installedModules[moduleId] = {
			/******/exports: {},
			/******/id: moduleId,
			/******/loaded: false
			/******/ };

		/******/ // Execute the module function
		/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

		/******/ // Flag the module as loaded
		/******/module.loaded = true;

		/******/ // Return the exports of the module
		/******/return module.exports;
		/******/
	}

	/******/ // expose the modules object (__webpack_modules__)
	/******/__webpack_require__.m = modules;

	/******/ // expose the module cache
	/******/__webpack_require__.c = installedModules;

	/******/ // __webpack_public_path__
	/******/__webpack_require__.p = "";

	/******/ // Load entry module and return exports
	/******/return __webpack_require__(0);
	/******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports) {

	var scrollpos = window.scrollY;
	var body = document.querySelector("body");
	var header = document.querySelector(".header");
	var header_height = header.offsetHeight;
	var add_class_on_scroll = function add_class_on_scroll() {
		return body.classList.add("is-scrolling");
	};
	var remove_class_on_scroll = function remove_class_on_scroll() {
		return body.classList.remove("is-scrolling");
	};
	window.addEventListener('scroll', function () {
		scrollpos = window.scrollY;
		if (scrollpos >= header_height) {
			add_class_on_scroll();
		} else {
			remove_class_on_scroll();
		}
	});

	// var defaultDuration = 777 // ms
	// var edgeOffset = 156 // px
	// zenscroll.setup(defaultDuration, edgeOffset)

	/***/
}]
/******/);